import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './DataCyber.css';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionCyberData from '../../components/CyberData/IntroSectionCyberData/IntroSectioncyberData';
import IntroSectionCyberData2 from '../../components/CyberData/IntroSectionCyberData/IntroSectionCyberData2';
import IntroSectionCyberData3 from '../../components/CyberData/IntroSectionCyberData/IntroSectionCyberData3';
import ServicesCardsCyberData from '../../components/CyberData/ServicesCardsCyberData/ServicesCardsCyberData';
import ExpertiseSectionAdminCloud from '../../components/AdminCloud/ExpertiseSectionAdminCloud/ExpertiseSectionAdminCloud'
import PricingPrivateCloud from '../../components/PrivateCloud/PricingPrivateCloud/PricingPrivateCloud';
import ContactSection from '../../components/HomePage/ContactSectionHome/ContactSectionHome';
import ScrollingLogos from '../../components/Common/ScrollingLogos/ScrollingLogos';
import Navbar from '../../components/Common/Navbar/Navbar'
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ServiceList from '../../components/CyberData/ServicesSliderCyberData/ServicesSliderCyberData';
import ExpertiseSectionCyberData from '../../components/CyberData/ExpertiseSectionCyberData/ExpertiseSectionCyberData';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData10 from '../../components/Common/IntroSectionBottom/introSectionData10';
import useSectionRefs from '../../hooks/useSectionRefs';
import BenefitsPrivateCloud from '../../components/CyberData/ServicesSliderCyberData/BenefitsPrivateCloud';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import TimelinePrivateCloud from '../../components/CyberData/Timeline/TimelinePrivateCloud';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import PricingSectionAzureDataCyber from '../../components/ui/pricing-section-azure-datacyber';

const DataCyber: React.FC = () => {
    const sectionRefs = useSectionRefs();
    const { t } = useTranslation();
  
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

  return (
    <div>
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('dataCyber.header.title', 'Data Leaks Sentinel')} 
            subtitle={t('dataCyber.header.subtitle', 'Surveillance active des fuites de données.')} 
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionCyberData />
      </section>

      <section id="commitment" className="section light commitment-section" ref={sectionRefs.commitment}>
        <IntroSectionCyberData3 />
      </section>

      <section id="cloud" className="section dark" ref={sectionRefs.cloud}>
        <IntroSectionCyberData2 />
      </section>

      <section id="services" className="section light" ref={sectionRefs.services}>
        <IntroSectionBottom data={introSectionData10} translationNamespace="dataCyber" />
      </section>
        <div className="gradient-bg">
      <section id="start2" className="section light" ref={sectionRefs.start2}>
        <PricingSectionAzureDataCyber openContactModal={handleOpenContactModal} />
      </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
          <ExpertiseSectionCyberData />
          <BenefitsPrivateCloud />
          <TimelinePrivateCloud />
          <GridPatternCard>
      <GridPatternCardBody>
        <div className="tw-h-[5em]">
        </div>
      </GridPatternCardBody>
    </GridPatternCard>
          </section>
        </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="dataCyber" />
        <Footer />
      </section>
    </div>
    </div>
    </div>
  );
};

export default DataCyber;
